'use client';

import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import { useAccordionState } from './AccordionProvider';

type AccordionContentProps = {
  children: any;
  classes?: string;
  openClasses?: string;
};

function AccordionContent({ children, classes = '', openClasses = '' }: AccordionContentProps) {
  const { open } = useAccordionState();

  return (
    <div
      className={twMerge(
        'grid transform cursor-default overflow-hidden transition-[grid-template-rows] duration-[350ms] ease-[cubic-bezier(0.25,0.1,0.25,1.0)]',
        { 'grid-rows-[0fr]': !open },
        { 'grid-rows-[1fr]': open },
        classes,
        { [openClasses]: open },
      )}
    >
      <div className="overflow-hidden">{children}</div>
    </div>
  );
}

export default AccordionContent;
